import { Card, Link, Typography } from '@mui/material';
import { DEVELOPER_NAME } from 'src/constants/Developer';
import { HANABI_WEBSITE } from 'src/constants/Urls';

export const Footer = () => {
  return (
    <Card
      sx={{
        display: 'flex',
        flexDirection: 'row',
        gap: { xs: '8px', lg: '16px' },
        padding: { xs: '16px', lg: '8px 16px' },
        borderRadius: 0,
        alignItems: 'center',
        textAlign: { xs: 'center', lg: 'left' },
      }}
    >
      <Typography
        sx={{ flex: { xs: 2, sm: 'none' } }}
        component={'p'}
        variant="body2"
      >
        A product of{' '}
        <Link
          id="hanabi_website_url"
          href={HANABI_WEBSITE}
          referrerPolicy="no-referrer"
          target="_blank"
        >
          {DEVELOPER_NAME}
        </Link>
      </Typography>
    </Card>
  );
};
